<script setup>
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  content: {
    type: Array,
    default: () => [],
  },
  media: {
    type: Object,
    default: () => ({}),
  },
});

const videoHeight = computed(() => props.media.height ?? 204.75);
const videoWidth = computed(() => props.media.width ?? 364);
</script>

<template>
  <div data-testid="defaultStepLayout">
    <h5 :class="$style.title">
      <XIcon
        v-if="icon"
        :class="$style.icon"
        icon-style="fal"
        :icon="icon"
        size="lg"
        data-testid="defaultStepLayoutTitleIcon"
      />
      {{ title }}
    </h5>
    <div :class="$style.body">
      <div
        :class="$style.content"
        data-testid="defaultStepLayoutContent"
      >
        <p
          v-for="(paragraph, index) in content"
          :key="index"
          :class="$style.stepDescription"
        >
          {{ paragraph }}
        </p>
      </div>
      <div
        v-if="media.url"
        :class="$style.media"
        data-testid="defaultStepLayoutMedia"
      >
        <iframe
          :height="videoHeight"
          :width="videoWidth"
          sandbox="allow-same-origin allow-scripts allow-presentation"
          :class="$style.video"
          :src="media.url"
          :title="title"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write;
            encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.title {
  display: flex;
  align-items: center;
  margin-bottom: var(--space-medium);
  gap: var(--space-small-xx);
  font-weight: var(--font-weight-bold);
}

.body {
  display: flex;
  margin-bottom: var(--space-regular);
  gap: var(--space-medium);

  .content {
    display: flex;
    flex-direction: column;
    gap: var(--space-regular);

    .stepDescription {
      margin-bottom: 0;
    }
  }

  .media {
    display: flex;
    align-items: center;
    margin: auto;
    background-color: var(--color-neutral-500);
    border-radius: var(--border-radius-regular);

    iframe {
      border-radius: var(--border-radius-regular);
    }
  }
}
</style>
